import { UpdateUserRequest } from '../types/Dtos/request';
import { GetLoggedUserResponse } from '../types/Dtos/response';
import { aiApi } from '../utils/aiApi';

const BASE = 'v1/users';

export const getLoggedUser = (token?: string) => {
  if (token) {
    return aiApi.get<GetLoggedUserResponse>(`${BASE}/logged`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return aiApi.get<GetLoggedUserResponse>(`${BASE}/logged`);
};

export const updateDefaultOrganization = (organizationId: string) =>
  aiApi.put(`${BASE}/logged/organizations/${organizationId}/default`);

export const updateUserProfile = (payload: UpdateUserRequest) =>
  aiApi.put(`${BASE}/logged`, payload);
